import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Users, Pill } from "lucide-react";
import { FaUserMd, FaClinicMedical, FaUserNurse, FaHospitalUser } from "react-icons/fa";
import {
  PROFESSIONAL_DASHBOARD_ROUTES,
  professionalDashboardUrl,
} from "../../config/appConfig";
import SupportContact from "../../components/supportContact/SupportContact";
import "./IntroPage.css";

// Every role, in display order. A page shows the options its `routes` map supports: all five on
// the main page, the two doctor consultation options on the consultation registration link.
const ROLE_OPTIONS = [
  { value: "doctor", label: "Doctor Online Consultation", Icon: FaUserMd },
  { value: "pharmacy", label: "Pharmacy", Icon: Pill },
  { value: "doctor-home-consultation", label: "Doctor Home Consultation", Icon: FaClinicMedical },
  { value: "nurse", label: "Nurse", Icon: FaUserNurse },
  { value: "physiotherapy-imaging-lab", label: "Physiotherapy / Imaging / Lab Center", Icon: FaHospitalUser },
];

const Introduction = ({ routes = PROFESSIONAL_DASHBOARD_ROUTES, heading }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const options = ROLE_OPTIONS.filter((option) => routes[option.value]);

  const handleSubmit = () => {
    if (!selectedOption) {
      toast.error("Please select an option before continuing.");
      return;
    }

    // Was a five-branch if/else, each branch repeating the literal professional-console hostname.
    // The destination now comes from config so this app does not carry another application's URL.
    const destination = professionalDashboardUrl(selectedOption, routes);

    if (!destination) {
      toast.error("This option is not available right now. Please try again later.");
      return;
    }

    window.location.href = destination;
  };

  return (
    <>
      <ToastContainer />

      <div className="page-container">
        <div className="modal-overlay">
          <div className="modal-card">
            {heading && <h1 className="page-heading">{heading}</h1>}
            <div className="title-section">
              <Users className="title-icon" />
              <h2 className="modal-title">Select Your Role</h2>
            </div>
            <p className="modal-subtitle">Choose your professional role to continue</p>

            <div className="radio-group">
              {options.map(({ value, label, Icon }) => (
                <label className="radio-option" key={value}>
                  <input
                    type="radio"
                    name="role"
                    value={value}
                    checked={selectedOption === value}
                    onChange={(e) => setSelectedOption(e.target.value)}
                  />
                  <div className="radio-custom"></div>
                  <div className="role-content">
                    <Icon className="role-icon" />
                    <span className="role-text">{label}</span>
                  </div>
                </label>
              ))}
            </div>

            <button
              className="modal-btn"
              onClick={handleSubmit}
              disabled={!selectedOption}
            >
              Continue
            </button>
          </div>

          <SupportContact />
        </div>
      </div>
    </>
  );
};

export default Introduction;
